

















import { BaseInput } from '#components/dms/common/baseInput';
import DmsWrapper from '#components/dms/form/Wrapper.vue';

export default BaseInput.extend({
	name: 'DmsDatePicker',
	components: { DmsWrapper },
	props: {
		value: [Date, String],
		type: {
			type: String as () => 'year' | 'month' | 'date' | 'dates' | 'datetime' | 'week',
			default: 'date',
		},
		pickerOptions: Object,
		span: {
			type: Number,
			default: 24,
		},
	},
	computed: {
        format(): 'dd.MM.yyyy HH:mm' | 'dd.MM.yyyy' | 'MMMM yyyy' | 'yyyy' |'yyyy/MM/dd' | 'yyyy/MM/dd HH:mm' {
            switch (this.type) {
                case 'datetime':
                    return  'yyyy/MM/dd HH:mm';
                case 'month':
                    return 'MMMM yyyy';
                case 'year':
                    return 'yyyy';
                default:
                    return 'yyyy/MM/dd';
            }
		},
	},
});
